var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    width: 25,
    height: 25,
    style: {
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 384H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32zM704 544H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32zM704 704H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M776.7 960H247.3C146.2 960 64 877.8 64 776.7V247.3C64 146.2 146.2 64 247.3 64h529.5c101 0 183.3 82.2 183.3 183.3v529.4C960 877.8 877.8 960 776.7 960zM247.3 128C181.5 128 128 181.5 128 247.3v529.4c0 65.8 53.5 119.3 119.3 119.3h529.5c65.8 0 119.3-53.5 119.3-119.3V247.3c0-65.8-53.5-119.3-119.3-119.3H247.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.0905ed3379c913980b179b46fb261376.svg";
export { ForwardRef as ReactComponent };